import React, { Component } from "react";
import '../styles/doc.css';

import {
    IconButton
} from '@material-ui/core/';

import RefreshIcon from '@material-ui/icons/Refresh'

import {
    isArrayValid
} from '../utils/Utils';

import DetectModel from './DetectModel';
import PubSub from 'pubsub-js'

class DetectModelRulesView extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            models: [],
            detectModels: [],
            alerts: [],
            dialog: null,
            messages: props.appContext.state.messages
        };
    }

    componentDidMount() {
        this.token = PubSub.subscribe('STORE_UPDATE', this.loadContent.bind(this));
        this.loadContent();
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.token);
    }

    componentDidUpdate(oldProps) {
        if (this.props.detectModels !== oldProps.detectModels) {
            this.loadContent();
        }
    }

    loadContent() {
        const { appContext: { stores: { DataTypesStore }}} = this.props;

        const models = this.props.models || DataTypesStore.getModels();
        const detectModels = this.props.detectModels || DataTypesStore.getDetectModels();
        const alerts = this.props.alerts || DataTypesStore.getAlertLevels();
        this.setState({ models, detectModels, alerts });
    }

    onCloseDialog() {
        this.setState({ dialog: null });
    }


    getReport(detectModel, model) {
        const { appContext } = this.props;
        const { alerts } = this.state;

        let rows = []
        if (isArrayValid(detectModel)) {
            for (let j = 0; j < detectModel.length; j++) {
                let nextModel = detectModel[j];
                rows.push(<div key={rows.length}><DetectModel appContext={appContext} readOnly={this.props.readOnly} alerts={alerts} detectModel={nextModel} model={model} onChange={(detectModel) => { this.props.onChange(detectModel) }} /></div>);
            }
        } else {
            rows.push(<div key={rows.length}><DetectModel appContext={appContext} readOnly={this.props.readOnly} alerts={alerts} detectModel={detectModel} model={model} /></div>);
        }
        return rows;
    }



    render() {
        const { error, progress, dialog, detectModels, models } = this.state;
        let report = (isArrayValid(detectModels) && isArrayValid(models)) ? this.getReport(detectModels, models) : null;

        return <table style={{ width: '98%' }}><tbody>
            <tr>
                <td align='right'>
                    {error}
                    <IconButton disabled={progress !== null} onClick={this.loadContent.bind(this, detectModels)}>{progress || <RefreshIcon />}</IconButton>
                </td>
            </tr>
            <tr>
                <td>
                    {report}
                    {dialog}
                </td>
            </tr>
        </tbody></table>
    }
}


export default DetectModelRulesView;
